export default __webpack_public_path__ + "static/media/logo.457b66ae.png";